const info = {
    CN: {
        //中文翻译
        banner: {
            title: "AI+大健康",
        },
        security: {
            title: "运用人工智能技术为医疗健康行业定制场景化的保障服务",
            text: "大健康 AI 行业主要是指将人工智能技术应用于医疗、健康管理、养老、制药等大健康相关领域，以实现智能化诊断、个性化治疗、精准健康管理、药物研发加速等目标。其框架涵盖基础层（如芯片、云计算等基础设施）、技术层（包括机器视觉、知识图谱、机器学习、深度学习、自然语言处理等）和应用层（智慧病案、临床决策支持系统、医疗影像、新药研发、基因检测、手术机器人等）",
        },
    },
    EN: {
        //英文翻译
        banner: {
            title: "AI+Healthcare",
        },
        security: {
            title: "Healthcare Service",
            text: "AI+Healthcare sector integrates AI across medical care, health management, senior care, and pharmacy. It enables smarter diagnostics, personalized therapies, precision health management, and accelarated drug development. Its framework comprises three tiers:  the Base Layer (chips, cloud computing), the Technology Layer (computer vision, knowledge graphs, ML/DL, NLP), and the Application Layer (smart health records, clinical decision support systems, medical imaging, drug R&D, genomic analysis, robotic surgery).",
        },
    },
};
export default info; //需要暴露出去
